import React, { useCallback, useEffect, useState } from "react";
import { Button, Modal, Table } from "antd";
import Title from "antd/es/typography/Title";
import TableEmptyContent from "../../../Components/TableEmptyContent/TableEmptyContent";
import { RiseOutlined, FallOutlined } from "@ant-design/icons";
import { RankingAlgorithmSettingsAPI } from "../../../API/admin/RankingAlgorithmSettinsAPI";
import { UploadDataAPI } from "../../../API/UploadDataAPI";
import { useNavigate } from "react-router-dom";

const TABLE_COLUMNS = [
  {
    title: "Spec No.",
    dataIndex: "spec_concat",
    key: "spec_concat",
    width: 150,
  },
  {
    title: "Card No.",
    dataIndex: "card_no",
    key: "card_no",
    width: 150,
  },
  {
    title: "Rank Score",
    dataIndex: "wpm_score",
    key: "wpm_score",
    render: (text) => <span>{text.toFixed(3)}</span>,
  },
  {
    title: "Critical defect score",
    dataIndex: "score_critical",
    key: "score_critical",
    render: (text) => <span>{text.toFixed(3)}</span>,
  },
  {
    title: "Specification score",
    dataIndex: "score_spec",
    key: "score_spec",
    render: (text) => <span>{text.toFixed(3)}</span>,
  },
  {
    title: "Regulatory score",
    dataIndex: "score_reg",
    key: "score_reg",
    render: (text) => <span>{text.toFixed(3)}</span>,
  },
  {
    title: "Raw findings rate normalised",
    dataIndex: "score_raw",
    key: "score_raw",
    render: (text) => <span>{text.toFixed(3)}</span>,
  },
  {
    title: "Task score",
    dataIndex: "score_task",
    key: "score_task",
    render: (text) => <span>{text.toFixed(3)}</span>,
  },
  {
    title: "Cost normalised",
    dataIndex: "score_cost",
    key: "score_cost",
    render: (text) => <span>{text.toFixed(3)}</span>,
  },
  {
    title: "Rank",
    dataIndex: "rank",
    key: "rank",
    align: "center",
    render: (text, record) => (
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <span>{text}</span>
        {record.flag === "up" && (
          <RiseOutlined style={{ marginLeft: "5px", color: "green" }} />
        )}
        {record.flag === "down" && (
          <FallOutlined style={{ marginLeft: "5px", color: "red" }} />
        )}
      </div>
    ),
  },
];

export const SimulateRankingModel = ({ open, setOpen, messageToast }) => {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const simulateRanking = useCallback(async () => {
    setSpinning(true);
    await RankingAlgorithmSettingsAPI.simulateRanking(localStorage.getItem("flight_model"))
      .then((res) => {
        if (res.data.status === true) {
          setDataSource(res.data.preview);
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch(() => {
        messageToast("error", "Failed to simulate ranking algorithm.");
      })
      .finally(() => {
        setSpinning(false);
      });
  }, [messageToast]);

  useEffect(() => {
    if (open) {
      simulateRanking();
    }
  }, [open, simulateRanking]);

  function backFun() {
    setOpen(false);
  }

  async function ReRunRankingAlgorithm() {
    setSubmitting(true);
    const queryParams = {
      params: {
        flight_model: localStorage.getItem("flight_model"),
      },
    };
    await UploadDataAPI.reRank(queryParams)
      .then((res) => {
        if (res.data.status === true) {
          messageToast("success", "Ranking algorithm re-run successfully.");
          setOpen(false);
          navigate("/ranking");
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch((err) => messageToast("error", "Internal Server Error"))
      .finally(() => setSubmitting(false));
  }

  return (
    <Modal
      open={open}
      okText="Apply"
      cancelText="Clear All"
      onCancel={() => backFun()}
      footer={[
        <Button key="back" type="text" onClick={backFun}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={ReRunRankingAlgorithm}
          loading={submitting}
        >
          Re-run Ranking Algorithm
        </Button>,
      ]}
      loading={spinning}
      width={1200}
    >
      <div style={{ padding: "10px" }}>
        <div
          style={{ marginBottom: "20px", borderBottom: "solid 1px #80808047" }}
        >
          <Title level={5}>Simulate Ranking</Title>
          <div>
            <Table
              locale={{
                emptyText: <TableEmptyContent />,
              }}
              rowKey="key"
              columns={TABLE_COLUMNS}
              dataSource={dataSource}
              className="antdTable"
              pagination={{
                pageSizeOptions: ["5", "10", "20", "50", "100"],
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
